import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-bootstrap";
import {
  carouselImage1,
  carouselImage2,
} from "../../store/types/appEssentials";
import Image from "../Image";


export default class DemoCarousel extends Component {

  render() {
    return (
      <div className="carsouel-div" >
        <Carousel className="carsol" controls={false} interval={2000} style={{ overFlow: "auto" }}>
          {/* {CarsouelArray.map((ele) => { */}
            <Carousel.Item style={{ zIndex: 1 }}>
              {
                !!this.props.empanellement ?
                <Image src={carouselImage1} alt="first slide" /> :
                <Image src={carouselImage2} alt="second slide" />
              }
            </Carousel.Item> 
       
        </Carousel>
      </div>
    );
  }
}
